import Vue from 'vue';
import VueI18n from 'vue-i18n';
import supportedLocales from "../config/supported-locales.js"

Vue.use(VueI18n);

export const PluginOptions = {
  locale: 'en-AU',
  fallbackLocale: 'en-US',
  localeDir: 'locales',
  enableInSFC: false,
};

function loadLocaleMessages() {
  const locales = require.context(
    // match the localeDir exported
    './locales',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );

  const messages = {};

  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);

    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });

  return messages;
}


export function getSupportedLocales() {

  let annotatedLocales = []

  for (const code of Object.keys(supportedLocales)) {

    annotatedLocales.push({

      code,

      name: supportedLocales[code]

    })

  }

  return annotatedLocales
}

export default new VueI18n({

  // Switching the || here will change the locale. I don't think this is right, but it works for now.
  locale: process.env.VUE_APP_I18N_LOCALE || 'en-US',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en-US',
  messages: loadLocaleMessages(),

});



// WEBPACK FOOTER //
// ./src/i18n.js